import { Component, OnInit, ViewChild } from '@angular/core';
import { PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { ExportFilesModalComponent } from '../export-files-modal/export-files-modal.component';

@Component({
    selector: 'app-list-automaker',
    templateUrl: './list-automaker.component.html',
    standalone: false
})
export class ListAutomakerComponent implements OnInit {
  @ViewChild('exportFilesModal') exportFilesModal: ExportFilesModalComponent;
  loading = false;
  tableConfig: TableConfig<AutomakerDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      code: { header: 'Cód.', sortable: true, cell: (item) => item.code },
      companyName: { header: 'Nome Fantasia', sortable: true, cell: (item) => item.company.tradeName, sortKey: 'company.tradeName' },
      tradeName: { header: 'Razão Social', sortable: true, cell: (item) => item.company.companyName, sortKey: 'company.companyName' },
      document: { header: 'CNPJ', sortable: true, cell: (item) => item.company.document, sortKey: 'company.document' },
      state: {
        header: 'UF',
        sortable: true,
        cell: (item) => item.company?.address?.city?.state?.code,
        sortKey: 'company.address.city.state.code'
      },
      enabled: { header: 'Ativo', cell: 'activeCell', sortable: true, sortKey: 'status' },
      actions: { cell: 'actionsCell', header: ' ' }
    }
  };

  filterForm: FormGroup = this.form.group({
    code: this.form.control('', { nonNullable: true }),
    companyName: this.form.control('', { nonNullable: true }),
    tradeName: this.form.control('', { nonNullable: true }),
    document: this.form.control('', { nonNullable: true }),
    status: this.form.control('', { nonNullable: true })
  });

  fetcher: PaginatorFetcher<AutomakerDto> = (filters: PaginatorFilters) => this.automakerService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<AutomakerDto>;

  constructor(private readonly form: FormBuilder, private readonly router: Router, private readonly automakerService: AutomakerService) {}

  get filterValues(): any {
    return {
      code: this.filterForm.value.code,
      companyName: this.filterForm.value.companyName,
      tradeName: this.filterForm.value.tradeName,
      document: this.filterForm.value.document,
      status: this.filterForm.value.status
    };
  }

  ngOnInit(): void {
    this.resetFilter();
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  redirectToEdit(item: AutomakerDto) {
    this.router.navigate([`/automakers/${item.id}/update`]);
  }

  redirectToImportOrders(item: AutomakerDto) {
    this.router.navigate([`/automakers/${item.id}/import-orders`]);
  }

  redirectToPriceTable(item: AutomakerDto) {
    this.router.navigate([`/automakers/${item.id}/prices`]);
  }

  openExportFilesModal(item: AutomakerDto) {
    this.exportFilesModal.open(item.id);
  }

  exportExcel() {
    this.loading = true;
    this.automakerService.exportExcel().subscribe({
      next: (response) => {
        const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const nomeBase = this.getFileNameFromHeader(response.headers) || 'CarDealer_Cadastro_OEs';
        const timestamp = this.getFormatedDateTime();
        a.download = `${nomeBase}_${timestamp}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  private getFileNameFromHeader(headers: any): string | null {
    const contentDisposition = headers.get('Content-Disposition');
    if (!contentDisposition) return null;

    const matches = /filename="([^"]+)"/.exec(contentDisposition);
    return matches && matches[1] ? matches[1] : null;
  }

  private getFormatedDateTime(): string {
    const agora = new Date();
    const data = agora.toISOString().split('T')[0];
    const hora = agora.getHours().toString().padStart(2, '0') + agora.getMinutes().toString().padStart(2, '0');
    return `${data}_${hora}`;
  }
}
